import {
  ChangeDetectionStrategy,
  Component,
  OnInit,
  input
} from "@angular/core";

@Component({
  selector: "app-invalid-info-box",
  templateUrl: "./invalid-info-box.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class InvalidInfoBoxComponent implements OnInit {
  text = input.required<string>();

  constructor() {}

  ngOnInit(): void {}
}
